import { createContext, useContext } from 'react';

/**
 * What the embedded build steps call themselves. The wizard's own wording is
 * the default; the Capability build flow names them for the format being built
 * ("Short Course Structure", "Generate Short Course Content").
 */
export interface BuildLabels {
  /** The Structure step's heading. */
  structureTitle: string;
  /** The Structure step's button, which starts content generation. */
  generateContent: string;
}

export const DEFAULT_BUILD_LABELS: BuildLabels = {
  structureTitle: 'Review Program Structure',
  generateContent: 'Build Lessons Now'
};

export const BuildLabelsContext = createContext<BuildLabels>(DEFAULT_BUILD_LABELS);

export const useBuildLabels = (): BuildLabels => useContext(BuildLabelsContext);
